<div class="dialog-header">
    <h2 class="dialog-title">Employee Enrollment</h2>
    <button mat-icon-button class="close-button" mat-dialog-close (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog-content">
    <div *ngIf="!isStepperVisible">
        <div *ngIf="data?.type !== 'update'">
            <form [formGroup]="firstFormGroup" class="form-section">
                <ng-template matStepLabel>Employment</ng-template>

                <mat-form-field appearance="outline">
                    <mat-label>Aadhaar Number</mat-label>
                    <input matInput formControlName="aadhaar_number" maxlength="12" />

                    <mat-error *ngIf="firstFormGroup.get('aadhaar_number')?.hasError('required')">
                        Aadhaar number is required
                    </mat-error>

                    <mat-error *ngIf="firstFormGroup.get('aadhaar_number')?.hasError('pattern')">
                        Only numbers allowed & must be 12 digits
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="dob">
                    <mat-label>Date of Birth</mat-label>
                    <input matInput type="date" formControlName="dob" [max]="today" (keydown)="$event.preventDefault()"
                        (paste)="$event.preventDefault()" />
                    <mat-error *ngIf="firstFormGroup.get('dob')?.hasError('required')">
                        Date of Birth is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Aadhaar Name</mat-label>
                    <input matInput formControlName="aadhaar_name" />
                    <mat-error *ngIf="firstFormGroup.get('aadhaar_name')?.hasError('required')">
                        Aadhar name is required
                    </mat-error>
                </mat-form-field>

                <div>
                    <button mat-raised-button color="primary" (click)="onSubmitEmployment()">
                        Proceed for Enrollment
                    </button>
                </div>
            </form>
        </div>
    </div>

    <div *ngIf="isStepperVisible">
        <mat-stepper orientation="vertical" [linear]="isLinear" #stepper>

            <mat-step [stepControl]="secondFormGroup">
                <form [formGroup]="secondFormGroup">
                    <ng-template matStepLabel>Master Details</ng-template>

                    <mat-form-field appearance="outline">
                        <mat-label>Temporary Enrollment ID</mat-label>
                        <input matInput formControlName="temp_emp_id" readonly tabindex="-1" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Aadhaar Number</mat-label>
                        <input matInput formControlName="aadhaar_number" readonly tabindex="-1" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Aadhaar Name</mat-label>
                        <input matInput formControlName="aadhaar_name" readonly tabindex="-1" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput type="text" formControlName="dob" readonly tabindex="-1" max="YY-mm-dd" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Select Branch</mat-label>
                        <mat-select [(ngModel)]="branch_id" name="branch_id"
                            (selectionChange)="onBranchChange($event.value)">
                            <mat-option *ngFor="let branch of branch_data" [value]="branch.id">
                                {{ branch.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="pcc-wrapper">
                        <mat-form-field appearance="outline">
                            <mat-label>Select Profit Cost Center</mat-label>
                            <mat-select [(ngModel)]="profit_cost_id" name="profit_cost_id"
                                (selectionChange)="onProfitCostChange($event.value)">
                                <mat-option *ngFor="let pcc of pcc_data" [value]="pcc.id">
                                    {{ pcc.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div *ngIf="manpowerData" class="manpower-display"
                            [ngClass]="{'red-alert': manpowerData?.manpower_left_pccc == 0}">
                            <div>Max Manpower : {{ manpowerData.total_manpower_pccc }}</div>
                            <div>Manpower Left : {{ manpowerData.manpower_left_pccc }}</div>
                            <div>Current Manpower : {{ manpowerData.current_manpower_pccc }}</div>
                        </div>
                    </div>

                    <mat-form-field appearance="outline">
                        <mat-label>Select Category</mat-label>
                        <mat-select [(ngModel)]="category_id" name="category_id"
                            (selectionChange)="onDesignationChange($event.value)">
                            <mat-option *ngFor="let category of category_data" [value]="category.id">
                                {{ category.category_name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="pcc-wrapper">
                        <mat-form-field appearance="outline">
                            <mat-label>Select Designation</mat-label>
                            <mat-select [(ngModel)]="designation_id" name="designation_id"
                                (selectionChange)="onChange($event.value)">
                                <mat-option *ngFor="let designation of designation_data" [value]="designation.id">
                                    {{ designation.designation }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div *ngIf="selectedDesignationManpower" class="designation-box"
                            [ngClass]="{'red-alert': selectedDesignationManpower?.max == 0}">
                            <span class="row-item">Max Manpower : <strong>{{ selectedDesignationManpower.max
                                    }}</strong></span>
                            <span class="row-item">Current Manpower : <strong>{{ selectedDesignationManpower.current
                                    }}</strong></span>
                            <span class="row-item">Manpower Left : <strong>{{ selectedDesignationManpower.left
                                    }}</strong></span>
                        </div>
                    </div>

                    <mat-form-field appearance="outline">
                        <mat-label>Select PAPLdesignation</mat-label>
                        <mat-select [(ngModel)]="PAPLdesignation_id" name="PAPLdesignation_id">
                            <mat-option *ngFor="let PAPLdesignation of PAPLdesignation_data"
                                [value]="PAPLdesignation.id">
                                {{ PAPLdesignation.PAPLdesignation }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Experience (in years)</mat-label>
                        <input matInput type="text" formControlName="experience" maxlength="2" pattern="[0-9]{1,2}"
                            (keypress)=" ($event.charCode >= 48 && $event.charCode <= 57)
                                            ? true
                                            : $event.preventDefault()
                                        " />
                        <mat-error *ngIf="secondFormGroup.get('experience')?.hasError('pattern')">
                            Enter a valid experience (1–2 digits)
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Father / Husband Name</mat-label>
                        <input matInput formControlName="father_husband_name" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Relation with Employee</mat-label>
                        <mat-select formControlName="relation_with_employee">
                            <mat-option value="Father">Father</mat-option>
                            <mat-option value="Husband">Husband</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Gender</mat-label>
                        <mat-select formControlName="gender">
                            <mat-option value="Male">Male</mat-option>
                            <mat-option value="Female">Female</mat-option>
                            <mat-option value="Transgender">Transgender</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Marital Status</mat-label>
                        <mat-select formControlName="marital_status" required>
                            <mat-option value="">Select Marital Status</mat-option>
                            <mat-option *ngFor="let ms of maritalStatus" [value]="ms">{{ ms }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="secondFormGroup.get('marital_status')?.hasError('required')">
                            Marital status is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Mobile Number (Linked with Aadhaar)</mat-label>
                        <input matInput type="text" formControlName="mobile_with_adhar" maxlength="10"
                            (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                        <mat-error *ngIf="secondFormGroup.get('mobile_with_adhar')?.hasError('required')">
                            Mobile number is required
                        </mat-error>

                        <mat-error *ngIf="secondFormGroup.get('mobile_with_adhar')?.hasError('pattern')">
                            Enter a valid 10-digit mobile number
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>WhatsApp Number</mat-label>
                        <input matInput type="text" formControlName="whatsapp_number" maxlength="10"
                            (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                        <mat-error *ngIf="secondFormGroup.get('whatsapp_number')?.hasError('pattern')">
                            Enter a valid 10-digit mobile number
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" formControlName="email" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Alternative Email</mat-label>
                        <input matInput type="email" formControlName="alternative_email" />
                    </mat-form-field>
                    <div class="form-section">
                        <h3 class="section-title">Present Address</h3>

                        <mat-form-field appearance="outline">
                            <mat-label>Address</mat-label>
                            <textarea matInput formControlName="present_address"></textarea>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>State</mat-label>
                            <input matInput formControlName="present_state" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>District</mat-label>
                            <input matInput formControlName="present_district" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Police Station (PS)</mat-label>
                            <input matInput formControlName="present_ps" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Post Office (PO)</mat-label>
                            <input matInput formControlName="present_po" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Village</mat-label>
                            <input matInput formControlName="present_village" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Block</mat-label>
                            <input matInput formControlName="present_block" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Tehsil</mat-label>
                            <input matInput formControlName="present_tehsil" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Gram Panchayat(GP)</mat-label>
                            <input matInput formControlName="present_gp" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Pincode</mat-label>
                            <input matInput type="text" formControlName="present_pincode" maxlength="6"
                                pattern="[0-9]{6}"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                            <mat-error *ngIf="secondFormGroup.get('present_pincode')?.hasError('pattern')">
                                Enter a valid 6-digit pincode
                            </mat-error>
                        </mat-form-field>


                        <mat-form-field appearance="outline">
                            <mat-label>Mobile Number </mat-label>
                            <input matInput type="text" formControlName="present_mobile_number" maxlength="10"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                            <mat-error *ngIf="secondFormGroup.get('present_mobile_number')?.hasError('pattern')">
                                Enter a valid 10-digit mobile number
                            </mat-error>
                        </mat-form-field>

                    </div>
                    <div class="form-section">
                        <div class="address-checkbox">
                            <mat-checkbox [checked]="sameAsPresentAddress" (change)="sameAsPresent($event)">
                                Same as Present Address
                            </mat-checkbox>
                        </div>
                        <h3 class="section-title">Permanent Address</h3>
                        <mat-form-field appearance="outline">
                            <mat-label>Address</mat-label>
                            <textarea matInput formControlName="permanent_addrs"
                                [readonly]="sameAsPresentAddress"></textarea>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>State</mat-label>
                            <input matInput formControlName="permanent_state" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>District</mat-label>
                            <input matInput formControlName="permanent_district" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Police Station (PS)</mat-label>
                            <input matInput formControlName="permanent_ps" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Post Office (PO)</mat-label>
                            <input matInput formControlName="permanent_po" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Village</mat-label>
                            <input matInput formControlName="permanent_village" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Block</mat-label>
                            <input matInput formControlName="permanent_block" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Tehsil</mat-label>
                            <input matInput formControlName="permanent_tehsil" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Gram Panchayat(GP)</mat-label>
                            <input matInput formControlName="permanent_gp" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Pincode</mat-label>
                            <input matInput type="text" formControlName="permanent_pincode" maxlength="6"
                                pattern="[0-9]{6}"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()"
                                [readonly]="sameAsPresentAddress" />
                            <mat-error *ngIf="secondFormGroup.get('permanent_pincode')?.hasError('required')">
                                Pincode is required
                            </mat-error>
                            <mat-error *ngIf="secondFormGroup.get('permanent_pincode')?.hasError('pattern')">
                                Enter a valid 6-digit pincode
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Mobile Number</mat-label>
                            <input matInput type="text" formControlName="permanent_mobile_number" maxlength="10"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()"
                                [readonly]="sameAsPresentAddress" />
                            <mat-error *ngIf="secondFormGroup.get('permanent_mobile_number')?.hasError('required')">
                                Mobile number is required
                            </mat-error>
                            <mat-error *ngIf="secondFormGroup.get('permanent_mobile_number')?.hasError('pattern')">
                                Enter a valid 10-digit mobile number
                            </mat-error>
                        </mat-form-field>

                    </div>

                    <div class="form-section">
                        <h3 class="section-title">Employee Details</h3>

                        <mat-form-field appearance="outline">
                            <mat-label>Blood Group</mat-label>
                            <mat-select formControlName="blood_group" required>
                                <mat-option value="">Select Blood Group</mat-option>
                                <mat-option *ngFor="let group of bloodGroups" [value]="group">{{ group }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="secondFormGroup.get('blood_group')?.hasError('required')">
                                Blood group is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Identification Mark</mat-label>
                            <input matInput formControlName="ID_mark_employee" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Nationality</mat-label>
                            <mat-select formControlName="nationality" required>
                                <mat-option value="">Select Nationality</mat-option>
                                <mat-option *ngFor="let n of nationality" [value]="n">{{ n }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="secondFormGroup.get('nationality')?.hasError('required')">
                                Nationality is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Religion</mat-label>
                            <mat-select formControlName="religion" required>
                                <mat-option value="">Select Religion</mat-option>
                                <mat-option *ngFor="let r of religion" [value]="r">{{ r }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="secondFormGroup.get('religion')?.hasError('required')">
                                Religion is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Caste</mat-label>
                            <mat-select formControlName="caste" required>
                                <mat-option value="">Select Caste</mat-option>
                                <mat-option *ngFor="let c of caste" [value]="c">{{ c }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="secondFormGroup.get('caste')?.hasError('required')">
                                Caste is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Health Insurance No</mat-label>
                            <input matInput formControlName="health_insurance_no" />
                        </mat-form-field>
                    </div>

                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button [disabled]="isDisabled" [ngClass]="{'disabled-class': isDisabled}" mat-raised-button
                            color="primary" (click)="onSubmitMaster()" matStepperNext> Save
                            Master</button>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="thirdFormGroup">
                <form [formGroup]="thirdFormGroup">
                    <ng-template matStepLabel>Qualification Details</ng-template>
                    <mat-form-field appearance="outline">
                        <mat-label>Education Level</mat-label>

                        <mat-select formControlName="education_type"
                            (selectionChange)="onEducationTypeChange($event.value)">

                            <mat-option value="below_10th">
                                Below 10th
                            </mat-option>

                            <mat-option value="10th_passout">
                                10th Passout
                            </mat-option>

                        </mat-select>
                    </mat-form-field>

                    <div formArrayName="qualifications">

                        <div *ngFor="let q of qualifications.controls; let i=index" [formGroupName]="i"
                            class="qualification-block">

                            <h4>
                                {{ q.get('qualification')?.value }}

                                <span *ngIf="q.get('mandatory')?.value" style="color:red">
                                    *
                                </span>
                            </h4>

                            <mat-form-field appearance="outline">
                                <mat-label>University / Board Name</mat-label>
                                <input matInput formControlName="university_board_name">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>College / Institute Name</mat-label>
                                <input matInput formControlName="college_institute_name">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Year of Passout</mat-label>

                                <mat-select formControlName="year_of_passout">
                                    <mat-option *ngFor="let y of years" [value]="y">
                                        {{ y }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Division / %</mat-label>
                                <input matInput formControlName="division_percent">
                            </mat-form-field>

                            <button mat-icon-button color="warn" type="button" *ngIf="i >= 3"
                                (click)="removeQualification(i)">

                                <mat-icon>delete</mat-icon>
                            </button>

                        </div>

                        <div class="mt-3" *ngIf="educationType === '10th_passout'">
                            <button mat-raised-button color="primary" type="button" (click)="addQualification()">
                                <mat-icon>add</mat-icon>
                                Add Qualification
                            </button>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" type="button" (click)="onSubmitQualification()"
                            matStepperNext>
                            Save Qualifications
                        </button>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="fourthFormGroup">
                <form [formGroup]="fourthFormGroup">
                    <ng-template matStepLabel>Bank Details</ng-template>

                    <mat-form-field appearance="outline"><mat-label>Name of Bank</mat-label>
                        <mat-select formControlName="name_bank" required (selectionChange)="onBankChange($event)">
                            <mat-option value="">Select Bank</mat-option>
                            <mat-option *ngFor="let bank of bankNames" [value]="bank">{{ bank }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="fourthFormGroup.get('name_bank')?.hasError('required')">Bank Name is
                            required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline"><mat-label>Other Bank Name</mat-label>
                        <input matInput formControlName="other_bank_name" />
                    </mat-form-field>

                    <mat-form-field appearance="outline"><mat-label>Name as per Passbook</mat-label><input matInput
                            formControlName="name_passbook" /></mat-form-field>

                    <mat-form-field appearance="outline"><mat-label>IFSC</mat-label><input matInput
                            formControlName="ifsc" /></mat-form-field>

                    <mat-form-field appearance="outline"><mat-label>Bank Account Number</mat-label><input matInput
                            formControlName="bank_account_number" /></mat-form-field>
                    <mat-form-field appearance="outline"><mat-label>Branch Name</mat-label><input matInput
                            formControlName="name_branch" /></mat-form-field>
                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" (click)="onSubmitBank()" matStepperNext> Save
                            Bankdetails</button>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="fiveFormGroup">
                <form [formGroup]="fiveFormGroup">
                    <ng-template matStepLabel>Nominee Details</ng-template>

                    <mat-form-field appearance="outline"><mat-label>Nominee Name</mat-label><input matInput
                            formControlName="nominee_name" /></mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Relationship</mat-label>
                        <mat-select formControlName="nominee_relation">
                            <mat-option value="">Select Relationship</mat-option>
                            <mat-option *ngFor="let relation of bloodRelations" [value]="relation"> {{ relation }} </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline"><mat-label>Date of Birth</mat-label>
                        <input matInput type="date" (keydown)="$event.preventDefault()"
                            (paste)="$event.preventDefault()" formControlName="nominee_dob" [max]="today" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Nominee Aadhaar Number</mat-label>
                        <input matInput formControlName="nominee_aadhaar_number" maxlength="12" minlength="12"
                            pattern="[0-9]*" inputmode="numeric" placeholder="Enter 12-digit Aadhaar" />
                        <mat-error *ngIf="fiveFormGroup.get('nominee_aadhaar_number')?.hasError('pattern')">
                            Aadhaar Number must be 12 digits
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Address</mat-label>
                        <input matInput formControlName="nominee_address" />
                    </mat-form-field>

                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" (click)="onSubmitNominee()" matStepperNext> Save
                            Nominee Details</button>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="sixFormGroup">
                <form [formGroup]="sixFormGroup">
                    <ng-template matStepLabel>Family Details</ng-template>

                    <div formArrayName="families">
                        <div *ngFor="let f of families.controls; let i = index" [formGroupName]="i"
                            class="family-block mb-4 p-3 border rounded-lg shadow-sm bg-gray-50">

                            <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
                                <!-- Family Member Name -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Family Member Name</mat-label>
                                    <input matInput formControlName="family_member" />
                                </mat-form-field>

                                <!-- Date of Birth -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Date of Birth</mat-label>
                                    <input matInput type="date" formControlName="family_member_dob" [max]="today"
                                        (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
                                </mat-form-field>

                                <!-- Relationship -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Relationship</mat-label>
                                    <mat-select formControlName="family_member_relation">
                                        <mat-option value="">Select Relationship</mat-option>
                                        <mat-option value="SPOUSE">SPOUSE</mat-option>
                                        <mat-option value="MOTHER">MOTHER</mat-option>
                                        <mat-option value="FATHER">FATHER</mat-option>
                                        <mat-option value="BROTHER">BROTHER</mat-option>
                                        <mat-option value="SISTER">SISTER</mat-option>
                                        <mat-option value="UNMARRIED DAUGHTER">UNMARRIED DAUGHTER</mat-option>
                                        <mat-option value="SON">SON</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <!-- Residence -->
                                <mat-form-field appearance="outline">
                                    <mat-label>Residence</mat-label>
                                    <input matInput formControlName="family_member_residence" />
                                </mat-form-field>
                            </div>

                            <div class="flex justify-end mt-2">
                                <button mat-icon-button color="warn" (click)="removeFamily(i)"
                                    *ngIf="families.length > 1">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>

                        <!-- Add More Button -->
                        <div class="mt-3">
                            <button mat-raised-button color="primary" type="button" (click)="addFamily()">
                                <mat-icon>add</mat-icon> Add Family Member
                            </button>
                        </div>
                    </div>

                    <!-- Step Controls -->
                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" type="button" (click)="onSubmitFamily()"
                            matStepperNext>
                            Save Family Details
                        </button>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="sevenFormGroup">
                <form [formGroup]="sevenFormGroup" class="epf-esic-form">
                    <ng-template matStepLabel>EPF & ESIC Details</ng-template>
                    <h3 class="section-title">ESIC Details</h3>

                    <mat-form-field appearance="outline">
                        <mat-label>ESIC Code</mat-label>
                        <input matInput formControlName="esic_code" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>ESIC IP Number</mat-label>
                        <input matInput formControlName="esic_ip_number" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>WCA / GPA</mat-label>
                        <mat-select formControlName="wca_gpa" (selectionChange)="onWcaGpaChange($event)">
                            <mat-option value="">Select WCA / GPA</mat-option>
                            <mat-option value="WCA">WCA</mat-option>
                            <mat-option value="GPA">GPA</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>WCA/GPA Expire Date</mat-label>
                        <input matInput type="date" formControlName="wca_gpa_expire_date" [max]="today"
                            (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>ESIC Date</mat-label>
                        <input matInput type="date" formControlName="esic_date" [max]="today"
                            (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
                    </mat-form-field>

                    <h3 class="section-title">PF Account</h3>

                    <mat-form-field appearance="outline">
                        <mat-label>PF Code</mat-label>
                        <input matInput formControlName="pf_code" required />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>UAN</mat-label>
                        <input matInput formControlName="uan" required />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>PF Account Number</mat-label>
                        <input matInput formControlName="pf_account_number" required />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>EPF Date</mat-label>
                        <input matInput type="date" formControlName="epf_date" [max]="today"
                            (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>EPF Rule</mat-label>
                        <mat-select formControlName="epf_rule">
                            <mat-option value="1">Yes</mat-option>
                            <mat-option value="0">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" (click)="onSubmitEpfEsic()"> Save Epfesic</button>
                    </div>
                </form>
            </mat-step>
            <!-- Document Uploads -->
            <mat-step [stepControl]="eightFormGroup">
                <form [formGroup]="eightFormGroup">
                    <ng-template matStepLabel>Document Uploads</ng-template>
                    <div class="document-upload-wrapper">
                        <!-- Master Documents -->
                        <div class="document-group">
                            <h3>Master Documents</h3>
                            <div class="document-grid">
                                <div class="file-upload-card">
                                    <label>Experience Certificate</label>
                                    <input type="file" formControlName="browse_experience"
                                        (change)="onDocumentSelected($event,'browse_experience')">
                                </div>
                                <div class="file-upload-card">
                                    <label>Passport Photo</label>
                                    <input type="file" formControlName="browse_passport_photo"
                                        (change)="onDocumentSelected($event,'browse_passport_photo')">
                                </div>
                                <div class="file-upload-card">
                                    <label>Aadhaar</label>
                                    <input type="file" formControlName="browse_aadhaar"
                                        (change)="onDocumentSelected($event,'browse_aadhaar')">
                                </div>
                            </div>
                        </div>
                        <!-- Qualification Documents -->
                        <div class="document-group">
                            <h3>Qualification Documents</h3>
                            <div class="document-grid">
                                <div class="file-upload-card" *ngFor="let q of qualifications.controls; let i=index">
                                    <label>{{ q.get('qualification')?.value }}</label>
                                    <input type="file" (change)="onFileSelected($event,i)"
                                        (change)="onQualificationDocumentSelected($event,i)">
                                </div>
                            </div>
                        </div>
                        <!-- Bank Documents -->
                        <div class="document-group">
                            <h3>Bank Documents</h3>
                            <div class="document-grid">
                                <div class="file-upload-card">
                                    <label>Passbook / Cheque</label>
                                    <input type="file" formControlName="pass_book_photo"
                                        (change)="onDocumentSelected($event,'pass_book_photo')">
                                </div>
                            </div>
                        </div>
                        <!-- Nominee Documents -->
                        <div class="document-group">
                            <h3>Nominee Documents</h3>
                            <div class="document-grid">
                                <div class="file-upload-card">
                                    <label>Nominee Aadhaar</label>
                                    <input type="file" formControlName="nominee_aadhaar_photo"
                                        (change)="onDocumentSelected($event,'nominee_aadhaar_photo')">
                                </div>
                            </div>
                        </div>
                        <!-- Family Documents -->
                        <div class="document-group">
                            <h3>Family Documents</h3>
                            <div class="document-grid">
                                <div class="file-upload-card" *ngFor="let f of families.controls; let i=index">
                                    <label>
                                        Family Member {{ i + 1 }}
                                    </label>
                                    <input type="file" (change)="onFileSelectedFamily($event,i)"
                                        (change)="onFamilyDocumentSelected($event,i)">
                                </div>
                            </div>
                        </div>
                        <!-- EPF / ESIC Documents -->
                        <div class="document-group">
                            <h3>EPF / ESIC Documents</h3>
                            <div class="document-grid">
                                <div class="file-upload-card">
                                    <label>ESIC Sheet</label>
                                    <input type="file" formControlName="esic_sheet"
                                        (change)="onDocumentSelected($event,'esic_sheet')">
                                </div>
                                <div class="file-upload-card">
                                    <label>Form 11 Sheet</label>
                                    <input type="file" formControlName="form11_sheet"
                                        (change)="onDocumentSelected($event,'form11_sheet')">
                                </div>
                                <div class="file-upload-card">
                                    <label>UAN Sheet</label>
                                    <input type="file" formControlName="uan_sheet"
                                        (change)="onDocumentSelected($event,'uan_sheet')">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button mat-button matStepperPrevious [disabled]="epfEsicSaved && !documentUploadCompleted">
                            Back
                        </button>
                        <button mat-raised-button color="primary" type="button" (click)="submitDocuments()">
                            Save Documents
                        </button>
                    </div>
                </form>
            </mat-step>
        </mat-stepper>
    </div>
</div>